import { connect } from 'react-redux';

import EmailSignatureView from './view.jsx';
import { updateEmailSignature } from 'src/redux/actions/users.ts';

const mapStateToProps = (state, ownProps) => {
  return {
    emailSignature: state.users.me.emailSignature,
    updating: state.users.emailSignature.updating,
    success: state.users.emailSignature.updated
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateEmailSignature: (emailSignature) => {
      return dispatch(updateEmailSignature(emailSignature));
    }
  }
}

const EmailSignatureContainer = connect (
    mapStateToProps,
    mapDispatchToProps
)(EmailSignatureView);

export default EmailSignatureContainer;